const Obj = {
  compare: function (obj, obj2) {
    /**
     * @Return {Boolean)
     */
    for (const p in obj) {
      if (obj.hasOwnProperty(p)) {
        if (obj[p] !== obj2[p]) {
          return false
        }
      }
    }
    for (const p in obj2) {
      if (obj2.hasOwnProperty(p)) {
        if (obj[p] !== obj2[p]) {
          return false
        }
      }
    }
    return true
  },
  is: function (obj) {
    /**
     * @Return {Boolean)
     */
    return typeof obj === 'object' && !Array.isArray(obj) && obj !== null
  }
}

export {
  Obj
}
